import { RootState } from "integrations/redux"
import { popupsSliceName } from "./slice"
import { SidePanelMode } from "panels/content/side-panel/constants"
import { SavedContact } from "@nova/schemas"

type ContextMenuTypesAndData = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Any: any
    SidePanelItem: {
        layerId: string
        selectedLayerIds: string[]
    }
    SidePanelList: {
        mode: SidePanelMode
    }
    SidePanelSort: never
    SidePanelMemberFilter: never
    Workspace: never
    WorkspaceBody: never
    WorkspaceSort: never
    WorkspaceSwitcher: never
    GridFolder: { folderId: string; fixedPosition: boolean }
    GridProject: { projectId: string; fixedPosition: boolean }
    ListFolder: { folderId: string; fixedPosition: boolean }
    ListProject: { projectId: string; fixedPosition: boolean }
    LicenseMenu:
        | { assigneeId: string; isUnassigned?: never; licenseId?: never }
        | { assigneeId?: never; isUnassigned: true; licenseId: string }
    WorkspaceSidePanel: {
        entityId: string
        isFavorite: boolean
        fixedPosition: boolean
    }
    PDF: { pdfId: string }
    EmailList: { emailListId: string }
    ContactList: { contactListId: string }
    SavedContact: { contact: SavedContact }
    Aircraft: { id: string; nickname: string }
    Mission: { missionId: string }
    MissionGroup: { groupId: string }
    ManageMissionGroup: { groupId: string }
    PiotTrackingConnectedAccount: { id: string; fixedPosition: boolean }
    PilotTrackingChecklistDetails: never
    AircraftNestedSidebarSort: never
    OverviewProject: { projectId: string }
}

export type ContextMenuKey = keyof ContextMenuTypesAndData

export type ContextMenu<T extends ContextMenuKey> =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | (T extends any
          ? [ContextMenuTypesAndData[T]] extends [never]
              ? {
                    type: T
                    position: { top: number; left: number }
                }
              : {
                    type: T
                    position: { top: number; left: number }
                    data: ContextMenuTypesAndData[T]
                }
          : never)
    | undefined

export const selectActiveContextMenu =
    <T extends ContextMenuKey>(key: T) =>
    (state: RootState): ContextMenu<T> => {
        const menu = state[popupsSliceName]["activeContextMenu"]
        if (menu && menu.type === key) {
            return menu as ContextMenu<T>
        }
        return undefined
    }
